import Vue from "vue";
import {DSPNotification$} from "@/shared-services";

const actionCt = {
  'assign-dialer-seat': (_, data) => DSPNotification$.subscribe(x => x('dialler', data[0].message)),
  'expired-cancel-dialer': (_, data) => DSPNotification$.subscribe(x => x('expired-cancel-dialer', data[0].message)),
  'upcoming-renewal-dialer': (_, data) => DSPNotification$.subscribe(x => x('upcoming-renewal-dialer', data[0].message)),
  'auto-renewal-dialer': (_, data) => DSPNotification$.subscribe(x => x('auto-renewal-dialer', data[0].message)),
  'insuranceExpiryNotify': (_, data) => DSPNotification$.subscribe(x => x('insuranceExpiryNotify', { ...data[0]})),
  'eld-task-leave': (_, data) => {
    if (localStorage.getItem('OneTime:eld-task-leave')) {
      return
    }
    localStorage.setItem('OneTime:eld-task-leave', 1)
    DSPNotification$.subscribe(x => x('eld-task-leave', { ...data[0], delay: 15}))
  },
}
const defaultAction = ({dispatch, rootState, commit}, data) => {
  if (rootState.im.UIControl.currentSessionAccount !== 'SYSTEM') {
    commit('NOTIFICATION_ADD_COUNT', data.length)
    if (localStorage.getItem('TP_PORTAL_TOKEN_V2') && window.location.href.indexOf('driverInvitation') === -1) {
      Vue.prototype.$tpNotification({
        title: "System Message",
        message: data[data.length - 1].message,
        showIcon: false,
        showClose: true,
        onClick: () => {
          dispatch('im/setCurrentSession', 'SYSTEM', { root: true });
          dispatch('im/setPutChat', false, { root: true });
        },
      })
    }
  }
  commit('NOTIFICATION_DISPATCH', data)
}
export const runAction = (store, data) => {
  const item = data[0];
  return (actionCt[item.module || item.type ] || defaultAction)(store, data)
}
